// extracted by mini-css-extract-plugin
module.exports = {"EcoAi":"EcoAi_EcoAi___L7cU"};